import { ImageSource } from 'yet-another-react-lightbox'

import { ImagePropertiesDto } from '@wwt/entities/api/search-response'

import {
	ASPECT_RATIO,
	COMMON_ORIGINAL_WIDTH
} from '@/features/Image/config/sizeResolutions'

export const getSrcParamsForSlide = (
	resolution: ImagePropertiesDto
): ImageSource => {
	const width = resolution.width ?? COMMON_ORIGINAL_WIDTH
	return {
		src: resolution.imageUrl,
		width,
		height: resolution.height ?? Math.round(width / ASPECT_RATIO)
	}
}
